<template>
  <b-card
    no-body
  >
    <div class="table-header m-2">
      <!-- Table Top -->
      <b-row>

        <!-- Add Student -->
        <b-col
          cols="12"
        >
          <div class="d-flex align-items-center justify-content-end flex-sm-row flex-column">
            <b-button
              v-if="$can('add-student', permissionSubjects.Academics)"
              v-b-modal.add-students-modal
              class="ml-1"
              variant="primary"
            >
            <span
              class="ml-25 align-middle"
            >Add Student</span>
            </b-button>
          </div>
        </b-col>

        <!-- Per Page -->
        <b-col
          cols="6"
          class="d-flex align-items-center justify-content-start mt-1"
        >
          <label class="mr-1 mb-0">Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            :reduce="option => option.value"
            class="per-page-selector d-inline-block ml-50 mr-1 m-pagination"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="6"
          class="d-flex align-items-center justify-content-end mt-1"
        >
          <label class="mr-1 mb-0">Search</label>
          <b-form-input
            v-model="searchQuery"
            placeholder="Search"
            class="w-25 w-sm-100"
            debounce="500"
          />
        </b-col>
      </b-row>
    </div>

    <div>
      <b-table
        ref="refClassStudentsTable"
        :items="fetchStudentsList"
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="No matching records found"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
      >
        <!-- Loader -->
        <template #table-busy>
          <TableSpinner />
        </template>

        <!-- Column: user_name -->
        <template #cell(user_name)="data">
          <b-avatar
            class="mr-1"
            size="32"
            :src="data.item.avatar"
          />
          <b-link
            :to="getUserViewRoutByType(data.item)"
          >{{ data.item.full_name }}</b-link>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">

          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="mx-auto p-0"
            no-caret
            right
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="$can('remove-student', permissionSubjects.Academics)"
              @click="removeFromClass(data.item.application_id)"
            >
              <span>Remove from class</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-if="totalItems && perPage !== 'all'"
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </div>
    <add-student-modal
      v-if="currentClassId"
      :selected-class-id="currentClassId"
      @success="updateStudentsList"
    />
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BPagination,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownItem,
  BAvatar,
  BLink,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import TableSpinner from '@/views/components/table-spinner/TableSpinner.vue'
import useClassDetails from './useClassDetails'
import AddStudentModal from './modals/AddStudentModal.vue'
import { permissionSubjects } from '@/libs/acl/constants'

export default {
  name: 'StudentsList',
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BAvatar,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BLink,
    BButton,

    vSelect,

    TableSpinner,
    AddStudentModal,
  },
  setup() {
    const {
      fetchStudentsList,
      removeStudentFromClass,
      tableColumns,
      isLoading,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      totalItems,
      isSortDirDesc,
      refClassStudentsTable,
      currentClassId,

      refetchData,
    } = useClassDetails()

    return {
      fetchStudentsList,
      removeStudentFromClass,
      tableColumns,
      isLoading,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      totalItems,
      isSortDirDesc,
      refClassStudentsTable,
      currentClassId,

      refetchData,
    }
  },
  data() {
    return {
      permissionSubjects,
    }
  },
  methods: {
    async removeFromClass(applicationId) {
      const formData = {
        group_id: this.currentClassId,
        application_id: applicationId,
      }
      await this.removeStudentFromClass(formData)
      this.updateStudentsList()
    },
    getUserViewRoutByType(item) {
      if (item.is_student) {
        return { name: 'admin-application-edit', params: { id: item.application_id, type: this.camperStudent(1) } }
      }
      return { name: 'admin-application-edit', params: { id: item.application_id, type: 'Staff' } }
    },
    updateStudentsList() {
      this.refetchData()
      this.$emit('refetchData')
    },
  },
}
</script>`

<style lang="scss" scoped>
  .table-header {

    label {
      margin-bottom: 0;
    }
  }
  .per-page-selector {
    width: 90px;
  }

</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .table-actions {
    width: 100px;
  }
  @media (max-width: 769px) {
    .m-pagination .vs__selected-options {
      .vs__search {
        display: none !important;
      }
    }
  }
  @media (max-width: 769px) {
    /* CUSTOM WIDTHS */
    .w-sm-100 { width: 100%!important; }
  }

</style>
